import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

export async function getActiveWorkSessionForToday(userId: string) {
    const now = new Date();
    const utcOffsetEcuador = -5 * 60; // Ecuador UTC-5

    const localNow = new Date(now.getTime() + utcOffsetEcuador * 60 * 1000);

    const startOfDay = new Date(localNow);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(localNow);
    endOfDay.setHours(23, 59, 59, 999);

    const startIso = new Date(startOfDay.getTime() - utcOffsetEcuador * 60 * 1000).toISOString();
    const endIso = new Date(endOfDay.getTime() - utcOffsetEcuador * 60 * 1000).toISOString();

    try {
        const response = await databases.listDocuments(
            import.meta.env.VITE_APPWRITE_DATABASE_ID,
            import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
            [
                Query.equal("userId", userId),
                Query.contains("status", ["active", "break"]), // Cambiado para incluir ambos estados
                Query.greaterThanEqual("createdAt", startIso),
                Query.lessThanEqual("createdAt", endIso),
                Query.orderDesc("createdAt") // Obtenemos la más reciente primero
            ]
        );

        // Seleccionamos la sesión más reciente que esté activa o en break
        const activeSessions = response.documents.filter(doc => 
            doc.status === "active" || doc.status === "break"
        );

        if (activeSessions.length > 0) {
            return {
                ...activeSessions[0],
                totalBreakTime: activeSessions[0].totalBreakTime || 0, // Aseguramos valor por defecto
                breaksTaken: activeSessions[0].breaksTaken || 0, // Aseguramos valor por defecto
                breakLimitReached: activeSessions[0].breakLimitReached || false // Aseguramos valor por defecto
            };
        }
        return null;
    } catch (error) {
        console.error("Error fetching active work session:", error);
        throw error; // Mejor re-lanzar el error para manejo superior
    }
}